/**
 * @generated SignedSource<<607332b4f5d87f637cfa89d679ff6d83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CorpTypeEnum = "CORPS" | "INDIS";
export type ErrorType = "ERR_ADSLOT" | "ERR_CARD_BIRTH" | "ERR_CARD_EXPIRED" | "ERR_CARD_NUMBER" | "ERR_CARD_PASSWORD" | "ERR_CARD_PASSWORD_FIVE_TIMES" | "ERR_CREATE_SURVEY_ANSWER" | "ERR_DUPLICATE_APPLY" | "ERR_ETC" | "ERR_EXIST_FINISH_REFUND" | "ERR_EXIST_SEARCH_HISTORY" | "ERR_EXPIRE_URL" | "ERR_HECTO_ETC" | "ERR_HOMETAX_BLOCK_ID" | "ERR_HOMETAX_CALCULATE" | "ERR_HOMETAX_COLLECT" | "ERR_HOMETAX_ETC" | "ERR_HOMETAX_EXPIRE_CERT" | "ERR_HOMETAX_IMPOSSIBLE" | "ERR_HOMETAX_INPUT" | "ERR_HOMETAX_NO_BMAN" | "ERR_HOMETAX_NO_CONTINUE_BMAN" | "ERR_HOMETAX_NO_CORPS_ID" | "ERR_HOMETAX_NO_INCOME_TAX" | "ERR_HOMETAX_NO_JUMIN_ID" | "ERR_HOMETAX_NO_REGIST_CERT" | "ERR_HOMETAX_NO_USER" | "ERR_HOMETAX_OVERLOAD" | "ERR_HOMETAX_PASSWORD" | "ERR_HOMETAX_PASSWORD_CHANGE_REQUEST" | "ERR_HOMETAX_REG_NO" | "ERR_HOMETAX_SERVER_FIX" | "ERR_HOMETAX_SESSION" | "ERR_HOMETAX_SIMPLE_AUTH" | "ERR_HOMETAX_TIMEOUT" | "ERR_LEAVE_REASON" | "ERR_LEAVE_REASON_LOG" | "ERR_NON_PRODUCT_PROMOTION" | "ERR_NOT_EXIST_HISTORY" | "ERR_NOT_EXIST_YEAR_END_TAX_SETTLEMENT" | "ERR_NO_EQUAL_TIN" | "ERR_PROMOTION" | "ERR_SSO" | "ERR_SURVEY" | "ERR_SURVEY_ANSWER" | "ERR_SURVEY_COMPLETED" | "ERR_SURVEY_EXPIRED" | "ERR_UPDATE_SURVEY_ANSWER" | "ERR_USER" | "ERR_USER_ACTION_LOG" | "ERR_USER_PHONE";
export type LoginType = "CommonCert" | "HometaxId" | "Kakao" | "Naver" | "PartnerCert";
export type Certificate = {
  signCert: string;
  signPri: string;
  signPw: string;
};
export type HometaxAccount = {
  id: string;
  password: string;
  resno?: string | null | undefined;
};
export type SimpleAuth = {
  token: string;
};
export type hometaxLoginMutation$variables = {
  certificate?: Certificate | null | undefined;
  corpType: CorpTypeEnum;
  hometaxAccount?: HometaxAccount | null | undefined;
  loginType: LoginType;
  simpleAuth?: SimpleAuth | null | undefined;
};
export type hometaxLoginMutation$data = {
  readonly hometaxLogin: {
    readonly errors: {
      readonly code: ErrorType;
    } | null | undefined;
    readonly refundToken: string | null | undefined;
    readonly result: boolean;
  };
};
export type hometaxLoginMutation = {
  response: hometaxLoginMutation$data;
  variables: hometaxLoginMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "certificate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "corpType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hometaxAccount"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loginType"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "simpleAuth"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "certificate",
        "variableName": "certificate"
      },
      {
        "kind": "Variable",
        "name": "corpType",
        "variableName": "corpType"
      },
      {
        "kind": "Variable",
        "name": "hometaxAccount",
        "variableName": "hometaxAccount"
      },
      {
        "kind": "Variable",
        "name": "loginType",
        "variableName": "loginType"
      },
      {
        "kind": "Variable",
        "name": "simpleAuth",
        "variableName": "simpleAuth"
      }
    ],
    "concreteType": "HometaxLoginOutput",
    "kind": "LinkedField",
    "name": "hometaxLogin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Errors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refundToken",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "hometaxLoginMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "hometaxLoginMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "318474098d928a6a8de49c0dcd65024c",
    "id": null,
    "metadata": {},
    "name": "hometaxLoginMutation",
    "operationKind": "mutation",
    "text": "mutation hometaxLoginMutation(\n  $corpType: CorpTypeEnum!\n  $loginType: LoginType!\n  $certificate: Certificate\n  $hometaxAccount: HometaxAccount\n  $simpleAuth: SimpleAuth\n) {\n  hometaxLogin(corpType: $corpType, loginType: $loginType, certificate: $certificate, hometaxAccount: $hometaxAccount, simpleAuth: $simpleAuth) {\n    result\n    errors {\n      code\n    }\n    refundToken\n  }\n}\n"
  }
};
})();

(node as any).hash = "db1e8ca3cd3ea6f287637cb7d5fc62c6";

export default node;
